export function marketingPlansToBookItems<
  TMarketingPlan extends { state: string; insured: { id: string }; snoozeUntil?: unknown | null },
>(marketingPlans: TMarketingPlan[] = [], state: TMarketingPlan["state"]): TMarketingPlan[] {
  const seenInsuredIds = new Set<string>();
  const matchingMarketingPlans = marketingPlans.filter((marketingPlan) => marketingPlan.state === state);
  const activeMarketingPlans = matchingMarketingPlans.filter((marketingPlan) => !marketingPlan.snoozeUntil);
  const snoozedMarketingPlans = matchingMarketingPlans.filter((marketingPlan) => marketingPlan.snoozeUntil);

  return [...activeMarketingPlans, ...snoozedMarketingPlans].filter((marketingPlan) => {
    const { insured } = marketingPlan;

    if (seenInsuredIds.has(insured.id)) {
      return false;
    }

    seenInsuredIds.add(insured.id);
    return true;
  });
}
